import { memo, useMemo } from 'react';
import Layout from '../Layout';
import Heading6 from '../Heading6';
import { Box } from '@mui/material';
import Chart from '../ChartArea';
import TablePreview from '../Table';
import { DataReportPage } from 'interfaces/report';
import classes from './styles.module.scss';
// eslint-disable-next-line no-empty-pattern
interface Props {
  dataReportPage: DataReportPage
}
const percentageMap = {
  1: 100,
  2: 50,
  3: 50,
  4: 50,
  5: 33,
};
const Page3 = memo(({dataReportPage} : Props) => {
  const widthChart = useMemo(() => {
    return percentageMap[dataReportPage?.dataChart?.length] ?? 0
  },[dataReportPage?.dataChart])
  return (
    <Layout>
      <Heading6 $fontWeight={600} $colorName="--red">
        {dataReportPage.name}
      </Heading6>
      <Box pt={2}>
        {dataReportPage?.dataTable?.tableHeaders && 
          <TablePreview
            tableHeaders={dataReportPage.dataTable.tableHeaders}
            dataTables={dataReportPage.dataTable.dataTables}
          />
        }
      </Box>
      <Box className={classes.groupChart}  width={"100%"} pt={2} display={'flex'} gap={1} flexWrap={"wrap"}>
        {
          dataReportPage?.charts?.map(chart => {
            return(
              <Box width={`calc(${widthChart}% - 8px)`}>
                <Chart options={chart} />
              </Box>
            )
          })
        }
      </Box>
    </Layout>
  );
});
export default Page3
